module.exports = __webpack_public_path__ + "img/00-master-title.898259f9.png";